import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AnimatePresence, motion } from "framer-motion";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Framework from "@/pages/Framework";
import Industries from "@/pages/Industries";
import Contact from "@/pages/Contact";
import BookConsultation from "@/pages/BookConsultation";
import Admin from "@/pages/Admin";
import OperationalAssessment from "@/pages/OperationalAssessment";
import NotFound from "@/pages/NotFound";

const pageVariants = {
  initial: { opacity: 0, y: 24, filter: "blur(6px)" },
  enter: { opacity: 1, y: 0, filter: "blur(0px)" },
  exit: { opacity: 0, y: -16, filter: "blur(6px)" },
};

const pageTransition = {
  duration: 0.55,
  ease: [0.22, 0.61, 0.36, 1],
};

function Page({ children }) {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="enter"
      exit="exit"
      transition={pageTransition}
    >
      {children}
    </motion.div>
  );
}

function AnimatedRoutes() {
  const location = useLocation();

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Page><Home /></Page>} />
        <Route path="/about" element={<Page><About /></Page>} />
        <Route path="/services" element={<Page><Services /></Page>} />
        <Route path="/operational-assessment" element={<Page><OperationalAssessment /></Page>} />
        <Route path="/framework" element={<Page><Framework /></Page>} />
        <Route path="/industries" element={<Page><Industries /></Page>} />
        <Route path="/contact" element={<Page><Contact /></Page>} />
        <Route path="/book" element={<Page><BookConsultation /></Page>} />
        <Route path="/admin" element={<Page><Admin /></Page>} />
        <Route path="*" element={<Page><NotFound /></Page>} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AnimatedRoutes />
        <Toaster
          position="top-right"
          richColors
          toastOptions={{
            style: {
              fontFamily: "Manrope, sans-serif",
              borderRadius: "0.75rem",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
